import { __awaiter, __generator, __read } from "tslib";
export function getSearchEnvironment(searchConfigPromise, userEntitlementsPromise) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, searchConfig, userEntitlements, complianceEnvironment;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        searchConfigPromise,
                        userEntitlementsPromise,
                    ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 2]), searchConfig = _a[0], userEntitlements = _a[1];
                    complianceEnvironment = searchConfig.complianceEnvironment;
                    if (userEntitlements.IsGovernment && complianceEnvironment === 'prod') {
                        return [2 /*return*/, 'gcc'];
                    }
                    return [2 /*return*/, complianceEnvironment];
            }
        });
    });
}
//# sourceMappingURL=getSearchEnvironment.js.map